import { Component, inject, signal } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../api.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { FluidModule } from 'primeng/fluid';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { APIError } from '../../../models/apierror';
import { MatIcon } from '../../components/mat-icon/mat-icon';
import { DatePickerModule } from 'primeng/datepicker';
import { TextareaModule } from 'primeng/textarea';
import { TAGRequest } from '../../../models/tagrequest';
import {
  newProgressDialogStep,
  ProgressDialogStep,
  ProgressDialogStepState,
  openProgressDialog,
} from '../../components/progressDialog/progressDialog';
import { DialogService } from 'primeng/dynamicdialog';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-request-form',
  imports: [
    TranslatePipe,
    ProgressSpinnerModule,
    FluidModule,
    ReactiveFormsModule,
    FloatLabelModule,
    InputTextModule,
    ButtonModule,
    MatIcon,
    DatePickerModule,
    TextareaModule,
    RouterLink
],
  providers: [TranslateService, DialogService],
  templateUrl: './request-form.html',
  styleUrl: './request-form.scss',
})
export class RequestForm {
  private dialogService = inject(DialogService);
  private translate = inject(TranslateService);
  private messageService = inject(MessageService);
  //private router = inject(Router);
  //private route = inject(ActivatedRoute);
  //private socket = inject(Socket);
  public api = inject(ApiService);
  //private sanitzer = inject(DomSanitizer);
  //private platformId = inject(PLATFORM_ID);
  //public timespan = inject(TimeSpanPipe);

  loadingPage = signal(true);
  submittingRequest = signal(false);
  loadingError = signal('');
  submitSuccess = signal(false);

  requestForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    location: new FormControl('', [Validators.required]),
    contact: new FormControl('', [Validators.required]),
    contactMail: new FormControl('', [Validators.required, Validators.email]),
    startdate: new FormControl(new Date(), [Validators.required]),
    enddate: new FormControl(new Date(), [Validators.required]),
    equipment: new FormControl('', [Validators.required]),
  });

  ngOnInit() {
    this.api
      .waitForAPI()
      .then(() => {
        this.loadingPage.set(false);
      })
      .catch((reason: APIError) => {
        this.loadingPage.set(false);
        this.loadingError.set(reason.message);
      });
  }

  submitRequest() {
    if (!this.requestForm.valid) return;

    this.submittingRequest.set(true);
    this.submitSuccess.set(false);

    let createStep = newProgressDialogStep(
      new ProgressDialogStep(
        ProgressDialogStepState.WAITING,
        this.translate.translate('internal.requests.createProgress')(),
      ),
    );

    let progressDialog = openProgressDialog(this.dialogService, [createStep]);

    progressDialog.onChildComponentLoaded.subscribe((pDialog) => {
      createStep.update((s) => s.setState(ProgressDialogStepState.PROCESSING));

      let request = new TAGRequest(this.requestForm.value);

      this.api
        .newRequest(request)
        .then(async (result) => {
          createStep.update((s) => s.setState(ProgressDialogStepState.SUCCESS));
          await pDialog.finishDialog();
          this.submittingRequest.set(false);
          this.submitSuccess.set(true);
        })
        .catch((reason) => {
          createStep.update((s) => s.setState(ProgressDialogStepState.ERROR));
          createStep.update((s) => s.setSubtitle(reason.message));
          pDialog.finishDialog(-1);
          console.log(reason);
          this.submittingRequest.set(false);
          this.submitSuccess.set(false);
        });
    });
  }
}
